import { render, staticRenderFns } from "./ShiftManagementDetail.vue?vue&type=template&id=7133d230"
import script from "./ShiftManagementDetail.vue?vue&type=script&lang=ts"
export * from "./ShiftManagementDetail.vue?vue&type=script&lang=ts"
import style0 from "./ShiftManagementDetail.vue?vue&type=style&index=0&id=7133d230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports